import React from 'react';

const EmailErrorMessage = (
  <div>
    Email address can contain:{' '}
    <div>&apos;-&apos; between any letters and numbers</div>
    <div>&apos;+&apos; between any letters and numbers BEFORE the @</div>
    <div>At least 2 characters after the last &apos; . &apos;</div>
  </div>
);

export default EmailErrorMessage;
